export class TokenValidationError extends Error {

  constructor (feature) {
    super('Token is not valid.')
    this.name = 'TokenValidationError'
    this.feature = feature
  }

}

export class InternalServerError extends Error {

  constructor () {
    super('Internal server error')
    this.name = 'InternalServerError'
  }

}

export const SERVER_ERROR = 'serverError'
export const TECHNICAL_GLITCH_ERROR = 'technicalGlitchError'
export const IDLE_SESSION_TIMEOUT_ERROR = 'idleSessionTimeout'
export const MISSING_ONBOARDING_TOKEN_ERROR = 'missingOnboardingToken'
export const UNSUPPORTED_BROWSER_ERROR = 'unsupportedBrowser'



// WEBPACK FOOTER //
// ./src/utils/errorTypes.js